export default function AttachFindingFolderDirective() {
  return {
    template: require('./attach-finding-folder.html'),
    scope: {
      customerId: '=',
      findingId: '=',
      serviceId: '=',
      parentFolderId: '=',
      folderId: '=',
      folder: '=',
    },
    controller: 'AttachFindingFolderController',
    controllerAs: 'attachFindingFolderVM',
    bindToController: true,
    replace: true
  };
}
